up.status = (function () {
    const u = up.util;
    const e = up.element;
    const config = new up.Config(() => ({
        currentClasses: ['up-current'],
        activeClasses: ['up-active'],
        loadingClasses: ['up-loading'],
        revalidatingClasses: ['up-revalidating'],
        navSelectors: ['[up-nav]', 'nav'],
        noNavSelectors: ['[up-nav=false]'],
    }));
    let namedPreviewFns = new up.Registry('preview');
    const SELECTOR_LINK = 'a, [up-href]';
    function linkCurrentURLs(link) {
        return link.upCurrentURLs || (link.upCurrentURLs = new up.LinkCurrentURLs(link));
    }
    function getNavLocations(nav) {
        let layerRef = e.attr(nav, 'up-layer') || 'origin';
        let layers = up.layer.getAll(layerRef, { origin: nav });
        return u.compact(layers.map(getMatchableLayerLocation));
    }
    function updateNav(nav, links, { newLinks, anyLocationChanged }) {
        let currentLocations = (!anyLocationChanged && nav.upNavLocations) || getNavLocations(nav);
        if (newLinks || !u.isEqual(nav.upNavLocations, currentLocations)) {
            for (let link of links) {
                const isCurrent = linkCurrentURLs(link).isAnyCurrent(currentLocations);
                for (let currentClass of config.currentClasses) {
                    link.classList.toggle(currentClass, isCurrent);
                }
                e.setAttrPresence(link, 'aria-current', 'page', isCurrent);
            }
            nav.upNavLocations = currentLocations;
        }
    }
    function updateNavsAround(root, opts) {
        const navSelector = config.selector('navSelectors');
        const fullNavs = e.around(root, navSelector);
        for (let fullNav of fullNavs) {
            let links = e.subtree(fullNav, SELECTOR_LINK);
            updateNav(fullNav, links, opts);
        }
    }
    function getMatchableLayerLocation(layer) {
        return u.matchableURL(layer.location);
    }
    function findActivatableAreas(element) {
        return element.upExpandedPair || [element];
    }
    function runPreviews(request, renderOptions) {
        let { bindLayer } = request;
        let focusCapsule = up.FocusCapsule.preserve(bindLayer);
        let applyPreviews = () => doRunPreviews(request, renderOptions);
        let revertPreviews = bindLayer.asCurrent(applyPreviews);
        focusCapsule === null || focusCapsule === void 0 ? void 0 : focusCapsule.autoVoid();
        return () => {
            bindLayer.asCurrent(revertPreviews);
            focusCapsule === null || focusCapsule === void 0 ? void 0 : focusCapsule.restore(bindLayer, { preventScroll: true });
        };
    }
    function doRunPreviews(request, renderOptions) {
        let { fragment, fragments, origin } = request;
        let cleaner = u.cleaner();
        let previewForFragment = (fragment) => new up.Preview({ fragment, request, renderOptions, cleaner });
        let singlePreview = previewForFragment(fragment);
        singlePreview.run(resolvePreviewFns(renderOptions.preview));
        singlePreview.run(getPlaceholderPreviewFn(renderOptions.placeholder));
        singlePreview.run(getFeedbackClassesPreviewFn(renderOptions.feedback, fragments));
        singlePreview.run(up.form.getDisablePreviewFn(renderOptions.disable, origin));
        for (let fragment of fragments) {
            let eachPreview = previewForFragment(fragment);
            eachPreview.run(up.fragment.matchSelectorMap(fragment, renderOptions.previewMap));
            eachPreview.run(up.fragment.matchSelectorMap(fragment, renderOptions.placeholderMap).flatMap(getPlaceholderPreviewFn));
        }
        return cleaner.clean;
    }
    function getPlaceholderPreviewFn(placeholder) {
        if (!placeholder)
            return;
        return function (preview) {
            preview.showPlaceholder(placeholder);
        };
    }
    function resolvePreviewFns(value) {
        if (u.isFunction(value)) {
            return [value];
        }
        else if (u.isString(value)) {
            return resolvePreviewString(value);
        }
        else if (u.isArray(value)) {
            return value.flatMap(resolvePreviewFns);
        }
        else {
            return [];
        }
    }
    function resolvePreviewString(str) {
        return u.map(u.parseScalarJSONPairs(str), ([name, parsedOptions]) => {
            let previewFn = namedPreviewFns.get(name);
            return function (preview, runOptions) {
                up.puts('[up-preview]', 'Showing preview %o', name);
                return previewFn(preview, parsedOptions || runOptions);
            };
        });
    }
    function getActiveElements({ origin, activeElements }) {
        activeElements || (activeElements = u.wrapList(origin));
        return u.flatMap(activeElements, findActivatableAreas);
    }
    function getFeedbackClassesPreviewFn(feedbackOption, fragments) {
        if (!feedbackOption)
            return;
        return function (preview) {
            const { renderOptions } = preview;
            if (renderOptions.expiredResponse) {
                preview.addClassBatch(fragments, config.revalidatingClasses);
            }
            else {
                preview.addClassBatch(getActiveElements(renderOptions), config.activeClasses);
                preview.addClassBatch(fragments, config.loadingClasses);
            }
        };
    }
    function statusOptions(element, options, parserOptions) {
        options = u.options(options);
        const parser = new up.OptionsParser(element, options, parserOptions);
        parser.booleanOrString('disable');
        parser.boolean('feedback');
        parser.string('preview');
        parser.booleanOrString('revalidatePreview');
        parser.string('placeholder');
        return options;
    }
    up.on('up:compilers:before', (_event, newFragment) => {
        updateNavsAround(newFragment, { newLinks: true, anyLocationChanged: false });
    });
    up.on('up:layer:location:changed up:layer:opened up:layer:dismissed up:layer:accepted', () => {
        updateNavsAround(document.body, { newLinks: false, anyLocationChanged: true });
    });
    return {
        config,
        preview: namedPreviewFns.put,
        resolvePreviewFns,
        runPreviews,
        statusOptions,
    };
})();
up.preview = up.status.preview;
